import { trackerTypes, trackerTypesEnum } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { getOrganizationNames } from "sources/admin";

const filter = ({ value }) => value !== trackerTypesEnum.Default && value !== trackerTypesEnum.Mobile;

const config = (disabled) => {
    return {
        deviceNumber: {
            // field
            label: "Номер",
            inputProps: { name: "deviceNumber", disabled },
            required: true,
            validators: [requiredField],
        },
        type: {
            // select
            label: "Тип трекера",
            inputProps: { name: "type", disabled },
            options: trackerTypes.filter(filter),
            menuPortalTarget: document.body,
            required: true,
            validators: [requiredField],
        },
        organizationId: {
            // select
            label: "Организация",
            inputProps: { name: "organizationId" },
            url: getOrganizationNames,
            propName: "name",
            menuPortalTarget: document.body,
        },
    };
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
